import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ca-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LabelComponent {
    public color = input.required<string>();
}
